<script>
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import { Pie, mixins } from 'vue-chartjs'

export default {
  components: {
    ChartJSPluginDatalabels,
  },
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object,
    options: Object,
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
